/**
 * @since 2026-04-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

export const APP_VERSION = "1.0.0";
